import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class ImageUploadUrlService {
  getVehicleImageUploadUrl(vehicleId: string): string {
    if (environment.imageApiEnabled) {
      return `${environment.imageApi}/vehicles/${vehicleId}/upload-image`;
    }
    return `${environment.api}/oemDealer/uploadVehicleImage/${vehicleId}`;
  }

  getOnlineEvalImageUploadUrl(evaluationId: string, verifCode: string): string {
    if (environment.imageApiEnabled) {
      return `${environment.imageApi}/online-evaluation/${evaluationId}/${verifCode}/upload-image`;
    }
    return `${environment.api}/onlineEvaluation/uploadEvalImage/${evaluationId}/${verifCode}`;
  }

  getVehicleVideoUploadUrl(vehicleId: string): string {
    if (environment.imageApiEnabled) {
      return `${environment.imageApi}/vehicles/${vehicleId}/upload-video`;
    }
    return `${environment.api}/oemDealer/uploadVehicleVideo/${vehicleId}`;
  }

  getEvalVehicleImageUploadUrl(vehicleId: string): string {
    if (environment.imageApiEnabled) {
      return `${environment.imageApi}/eval-vehicles/${vehicleId}/upload-image`;
    }
    return `${environment.api}/evaluation/uploadEvalImage/${vehicleId}`;
  }

  getEvalVehicleVideoUploadUrl(vehicleId: string): string {
    if (environment.imageApiEnabled) {
      return `${environment.imageApi}/eval-vehicles/${vehicleId}/upload-video`;
    }
    return `${environment.api}/evaluation/uploadEvalVideo/${vehicleId}`;
  }

  getOnlineEvalVideoUploadUrl(evaluationId: string, verifCode: string): string {
    if (environment.imageApiEnabled) {
      return `${environment.imageApi}/online-evaluation/${evaluationId}/${verifCode}/upload-video`;
    }
    return `${environment.api}/onlineEvaluation/uploadEvalVideo/${evaluationId}/${verifCode}`;
  }

  getVehicleReportPhotosUploadUrl(vehicleId: string): string {
    return `${environment.api}/oemDealer/vehicleReportPhotos/${vehicleId}`;
  }
}
